import { Classes, Icon, Tooltip } from '@blueprintjs/core'
import * as React from 'react'
import { Link } from 'react-router-dom'
import { EventLog } from '../../../types/api'
import { formatDate } from '../../../utils'
import { formatReadableDate } from '../utils'

interface Props {
  eventLog: EventLog
}

const EventLogEntry: React.FC<Props> = ({ eventLog }) => {
  const { createdAt, message, eventLink, actorName } = eventLog
  const linkOrText = eventLink ? <Link to={eventLink}>{message}</Link> : message
  return (
    <div className="entry">
      <div>
        <Icon icon="full-circle" className="node" />
      </div>
      <div className="message">
        {actorName && (
          <>
            {actorName} {linkOrText}
          </>
        )}
        {!actorName && linkOrText}
      </div>
      <div className={Classes.TEXT_MUTED} style={{ flex: '1', textAlign: 'right' }}>
        <Tooltip content={formatDate(createdAt, true)}>{formatReadableDate(createdAt)}</Tooltip>
      </div>
    </div>
  )
}

export { EventLogEntry }
